import(/* webpackMode: "eager", webpackExports: ["GoogleAnalytics"] */ "/vercel/path0/app/components/GoogleAnalytics.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Poppins\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":[\"300\",\"400\",\"500\",\"600\",\"700\"],\"display\":\"swap\",\"variable\":\"--font-poppins\",\"preload\":true}],\"variableName\":\"poppins\"}");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/styles/index.css");
